import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction, IPayload, IPayloadResult } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';
import { SERVER_API_URL } from 'app/config/constants';

import { IBookSubscription, defaultValue } from 'app/shared/model/book-subscription.model';

export const ACTION_TYPES = {
  FETCH_BOOKSUBSCRIPTION_LIST: 'bookSubscription/FETCH_BOOKSUBSCRIPTION_LIST',
  FETCH_BOOKSUBSCRIPTION: 'bookSubscription/FETCH_BOOKSUBSCRIPTION',
  CREATE_BOOKSUBSCRIPTION: 'bookSubscription/CREATE_BOOKSUBSCRIPTION',
  UPDATE_BOOKSUBSCRIPTION: 'bookSubscription/UPDATE_BOOKSUBSCRIPTION',
  DELETE_BOOKSUBSCRIPTION: 'bookSubscription/DELETE_BOOKSUBSCRIPTION',
  RESET: 'bookSubscription/RESET'
};

export declare type ICrudGetAllActionByUserIdAndBookId<T> = (
  page?: string | number,
  size?: string | number,
  sort?: string | number,
  userId?: string | number,
  bookId?: string | number
) => IPayload<T> | IPayloadResult<T>;

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IBookSubscription>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false
};

export type BookSubscriptionState = Readonly<typeof initialState>;

// Reducer

export default (state: BookSubscriptionState = initialState, action): BookSubscriptionState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_BOOKSUBSCRIPTION_LIST):
    case REQUEST(ACTION_TYPES.FETCH_BOOKSUBSCRIPTION):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_BOOKSUBSCRIPTION):
    case REQUEST(ACTION_TYPES.UPDATE_BOOKSUBSCRIPTION):
    case REQUEST(ACTION_TYPES.DELETE_BOOKSUBSCRIPTION):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_BOOKSUBSCRIPTION_LIST):
    case FAILURE(ACTION_TYPES.FETCH_BOOKSUBSCRIPTION):
    case FAILURE(ACTION_TYPES.CREATE_BOOKSUBSCRIPTION):
    case FAILURE(ACTION_TYPES.UPDATE_BOOKSUBSCRIPTION):
    case FAILURE(ACTION_TYPES.DELETE_BOOKSUBSCRIPTION):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_BOOKSUBSCRIPTION_LIST):
      return {
        ...state,
        loading: false,
        totalItems: action.payload.headers['x-total-count'],
        entities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_BOOKSUBSCRIPTION):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_BOOKSUBSCRIPTION):
    case SUCCESS(ACTION_TYPES.UPDATE_BOOKSUBSCRIPTION):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_BOOKSUBSCRIPTION):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = SERVER_API_URL + '/api/book-subscriptions';

// Actions

export const getEntities: ICrudGetAllActionByUserIdAndBookId<IBookSubscription> = (page, size, sort, userId, bookId) => {
  let requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  if (Number(userId) !== -1 && Number(bookId) !== -1) {
    requestUrl = `${apiUrl}${sort ? `?userId.equals=${userId}&bookId.equals=${bookId}&page=${page}&size=${size}&sort=${sort}` : ''}`;
  } else if (Number(userId) !== -1) {
    requestUrl = `${apiUrl}${sort ? `?userId.equals=${userId}&page=${page}&size=${size}&sort=${sort}` : ''}`;
  } else if (Number(bookId) !== -1) {
    requestUrl = `${apiUrl}${sort ? `?bookId.equals=${bookId}&page=${page}&size=${size}&sort=${sort}` : ''}`;
  }
  return {
    type: ACTION_TYPES.FETCH_BOOKSUBSCRIPTION_LIST,
    payload: axios.get<IBookSubscription>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`)
  };
};

export const getEntity: ICrudGetAction<IBookSubscription> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_BOOKSUBSCRIPTION,
    payload: axios.get<IBookSubscription>(requestUrl)
  };
};

export const createEntity: ICrudPutAction<IBookSubscription> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_BOOKSUBSCRIPTION,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IBookSubscription> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_BOOKSUBSCRIPTION,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const deleteEntity: ICrudDeleteAction<IBookSubscription> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_BOOKSUBSCRIPTION,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});

export const getEntitiesByUserIsCurrentUser: ICrudGetAllAction<IBookSubscription> = () => {
  const requestUrl = `${apiUrl}/user`;
  return {
    type: ACTION_TYPES.FETCH_BOOKSUBSCRIPTION_LIST,
    payload: axios.get<IBookSubscription>(requestUrl)
  };
};
